import React, {useEffect, useState} from "react";
import "./PackManHistory.scss";
import {HistoryCard} from "../HistoryCard/HistoryCard";
import {courierManagerArchivedOrders_api} from "../../SendManagement/SendManagementService";
import {ManagementHistoryCard} from "../../SendManagement/ManagementHistoryCard/ManagementHistoryCard";
import {orderPickerArchivedOrders_api} from "../PackManService";
import {PackManHistoryCard} from "./PackManHistoryCard";



function PackManHistory({data}) {

    const [history , set_history ] = useState([])
    const [status , set_status ] = useState("all")
    const [search , set_search ] = useState("")

    const orderPickerArchivedOrders_func= async ()=>{
        const response = await orderPickerArchivedOrders_api(1);
        console.log("history  : ",response.data)
        set_history(response.data.results)
    }

    useEffect(()=>{
        orderPickerArchivedOrders_func()
    },[])


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn");
            pageinate()
        }
    }
    const pageinate = async ()=>{
        window.HisPage = window.HisPage+1;
        try{
            const response = await orderPickerArchivedOrders_api(window.HisPage,status,search);
            set_history((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e);
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.HisPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])


    const doSearch = async (word)=>{
        if(word.length===0){
            window.HisPage = 1;
            set_search("");
            try{
                const response = await orderPickerArchivedOrders_api(1,status,word);
                set_history(response.data.results);
            }catch (e) {
                console.log(e);
            }
        }

        if(word.length>2){
            window.HisPage = 1;
            set_search(word);
            try{
                const response = await orderPickerArchivedOrders_api(1,status,word);
                set_history(response.data.results);
            }catch (e) {
                console.log(e);
            }
        }
    }

    const doFilter = async (filter)=>{
        window.HisPage = 1;
        set_status(filter);
        try{
            const response = await orderPickerArchivedOrders_api(1,filter,search);
            set_history(response.data.results);
        }catch (e) {
            console.log(e);
        }
    }


    return(
        <div>
            <div className="search-box">
                <input
                    onChange={(e)=>{
                        doSearch(e.target.value)
                    }}
                    type="text" name="" id="" placeholder="جستجوی سفارشات"/>
                <select name="" id=""
                        onChange={(e)=>{
                            doFilter(e.target.value)
                        }}
                >
                    <option value="">همه</option>
                    <option value="20">در حال ارسال</option>
                    <option value="13">آماده ارسال</option>
                    <option value="25">تحویل شده</option>
                    <option value="15">تحویل پیک شد</option>
                    <option value="30">کنسل شده</option>
                </select>
            </div>
            {history.length>0? <>
                {history.map(item=>{
                    return(
                         <PackManHistoryCard item={item}/>
                    )
                })}
            </>:<div className="empty-list">
                <i className="fa fa-database"></i>
                <span>سفارشی در لیست وجود ندارد</span>
            </div>
            }
        </div>
    )

}

export {PackManHistory};
